import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'
import * as z from 'zod'

/**
 * This schema verifies the payload received by the React application
 * has a known shape. The content inside "contentfulRawJsonResponse" should
 * be later validated by other schemas.
 */
export const PayloadSchema = z.lazy(() =>
  z.object({
    contentfulRawJsonResponse: z.looseObject({}),
    userLoggedIn: z.boolean().optional(),
    additionalProps: safeOptional(z.object({page: z.number(), totalPages: z.number()})),
  }),
)

export type Payload = z.infer<typeof PayloadSchema>

export function toPayload(payload: unknown): Payload {
  return PayloadSchema.parse(payload)
}
